import KeyboardBarcodeReader from '@/checkout-instore-legacy/utils/KeyboardBarcodeReader'
import * as WebViewBridge from '@/checkout-instore-legacy/utils/WebViewBridge'

const callbacks = []

function listen(callback) {
  KeyboardBarcodeReader.listen(callback)

  const handleWebViewBridgeEvent = (event) => {
    if (event.type === 'barcodeRead') {
      callback(event)
    }
  }

  WebViewBridge.listen(handleWebViewBridgeEvent)
  callbacks.push({
    callback,
    handleWebViewBridgeEvent,
  })

  return () => {
    unlisten(callback)
  }
}

function unlisten(callback) {
  const callbackIndex = callbacks.findIndex((cur) => cur.callback === callback)
  if (callbackIndex > -1) {
    KeyboardBarcodeReader.unlisten(callback)
    const { handleWebViewBridgeEvent } = callbacks[callbackIndex]
    WebViewBridge.unlisten(handleWebViewBridgeEvent)
    callbacks.splice(callbackIndex, 1)
  }
}

if (typeof window !== 'undefined') {
  window.BarcodeReader = { listen, unlisten }
}

export default { listen, unlisten }
